import ChannelAnalytics from "@/assets/svg/task/channel-analytics.svg";
import ProjectManagement from "@/assets/svg/task/project-management.svg";
import ScalableHiring from "@/assets/svg/task/scalable-hiring.svg";
import { Check } from "lucide-react";

export default function BuildForCreators() {
  const talentHub = [
    "Creative and production",
    "Growth and strategy",
    "Communications and collaboration",
    "Research and support",
    "Technical and platform support",
    "Creative and production",
    "Monetization and business",
    "Specialized and high-value roles",
  ];

  return (
    <div
      id="workflows"
      className="lg:py-10 mx-auto w-[90%] space-y-12 lg:space-y-20 4xl:max-w-[100rem]"
    >
      <div className="space-y-4 text-center">
        <h1 className="text-4xl md:text-5xl text-primaryLight">
          Built for creator workflows
        </h1>
        <p className="text-[#EDE9FE] max-w-2xl mx-auto text-sm md:text-lg">
          From editing to analytics, Enfinitask connects you with skilled
          professionals who understand your vision and ensure every task drives
          real progress.
        </p>
      </div>
      <div className="border-l border-r border-t rounded-t-[20px] border-[#434242] roundedd-lg p-8 md:p-12 relative flex flex-col lg:flex-row overflow-hidden gap-8">
        <div className="lg:w-[520px] space-y-6">
          <h1 className="text-primaryLight text-2xl md:text-4xl">
            All-in-one talent hub
          </h1>
          <p className="text-white">
            Enfinitask is a talent marketplace and task management platform
            designed for creators, agencies, and media brands. Focused on
            channel management, video editing, and thumbnail design, Enfinitask
            connects you with skilled professionals who help streamline your
            workflow and elevate your content.
          </p>
          <div className="space-y-2">
            {talentHub.map((talent, index) => (
              <div
                key={index}
                className="flex gap-2 items-center text-white font-light"
              >
                <Check className="text-primary" />
                {talent}
              </div>
            ))}
          </div>
        </div>
        <img
          src={ChannelAnalytics}
          className="lg:h-[310px] xl:h-[440px] 1xl:h-[500px] 4xl:h-[650px] lg:absolute bottom-0 4xl:-bottom-40 right-0"
          alt="Channel Analytics"
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-10 items-center">
        <img
          src={ProjectManagement}
          className="lg:h-[325px] xl:h-[410px] 1xl:h-[487px] 2xl:h-[490px] 4xl:h-[575px]"
          alt="Seamless Project Management"
        />
        <img
          src={ScalableHiring}
          className="lg:h-[325px] xl:h-[410px] 1xl:h-[487px] 2xl:h-[490px] 4xl:h-[575px]"
          alt="Flexible andd Scalable Hiring"
        />
      </div>
    </div>
  );
}
